<div *ngIf="loading; else loaded">Loading...</div>
<ng-template #loaded>
  <div *ngIf="addressAudits && addressAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list
      (nextPage)="onNextPage()"
      [audits]="addressAudits"
    ></sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No address audits </ng-template>
</ng-template>
